import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useRef,
} from "react";
import PyqSubjects from "./pyqmains";
import FileUpload from "./Fileupload";
import { getSubjects, getTopicsAndSubtopics } from "../services/mcqApi";
import { getSubjectsMains,getTopicsBySubject } from "../services/mainspractice";
import { Mic, Pause } from "lucide-react";
import "./ChatInput.css";
import { useNavigate, useLocation } from "react-router-dom";
// Load essay topics from JSON
const fetchEssayTopics = async () => {
  try {
    const response = await fetch("/data/pyqResponse.json");
    // console.log(response);

    if (!response.ok) throw new Error("Failed to load essay topics");
    return await response.json();
  } catch (error) {
    console.error("Error fetching essay topics:", error);
    return { selectText: "Select Topic", topics: [] };
  }
};

const ChatInput = forwardRef(
  (
    {
      showPremiumButton,
      setShowPremiumButton,
      showattachment,
      setAttachmark,
      setAttchsubject,
      setFiledetail,
      setMessages,
      selectedSubject,
      setMCQVisible,
      setIsMainsPracticeVisible,
      setEvaluateVisible,
      setDefaultText,
      setIsPrelims,
      setMessage,
      setSelectedPrompt,
      selectedPrompt,

      setSelectedSubject,
      isMCQVisible,
      message,
      isPrelims,
      setbuttonclicked,
      defaultText,
      isEvaluateVisible,
      isMainsPracticeVisible,
      dropdownPosition,
      onSend,
      isStreamingDone,
      setMsgSend,
      setdropdownVisibl,
      isdropdownVisibl,
      showPromptType,
      setShowPromptType,
      setPromptType,
    },
    ref
  ) => {
    // const [isPrelims, setIsPrelims] = useState(isPrelims);
    // const [message, setMessage] = useState(message);
    const [messageEdit, setMessageEdit] = useState("");
      const navigate = useNavigate();
    // const [selectedPrompt, setSelectedPrompt] = useState({
    //   text: "Generic",
    //   image: "summarise.svg",
    // });
    // const [selectedPromptPractice, setSelectedPromptPractice] = useState({
    //   text: "Generic",
    //   image: "summarise.svg",f
    // });
    const [attachFile, setAttachFile] = useState(false);
    const [modelans, setModeAns] = useState(false);
    const [demo, setDemo] = useState("");
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const [isDropdownVisiblePractice, setDropdownVisiblePractice] =
      useState(false);
    const [isButtonDisabled, setButtonDisabled] = useState(true);
    // const [selectedSubject, setSelectedSubject] = useState("");
    const [selectedNumQuestions, setSelectedNumQuestions] = useState("5");
    // const [isMCQVisible, setMCQVisible] = useState(isMCQVisible);
    // const [isEvaluateVisible, setEvaluateVisible] = useState(isEvaluateVisible);
    // const [isMainsPracticeVisible, setIsMainsPracticeVisible] = useState(isMainsPracticeVisible);
    // const [defaultText, setDefaultText] = useState(defaultText);
    const [essayTopics, setEssayTopics] = useState({});
    const [selectedTopic, setSelectedTopic] = useState("");
    const [selectedSubjectPyq, setselectedSubjectPyq] = useState("");
    const [subjects, setSubjects] = useState([]);
    const [subjectsmainpractice, setSubjectsMainPractice] = useState([]);
    const [topicsAndSubtopics, setTopicsAndSubtopics] = useState([]);
    const[mainstopics,setMainstopic]=useState([]);
    const [selectedSubtopic, setSelectedSubtopic] = useState("");
    const dropdownRef = useRef(null);

    const [isLoadingSubtopics, setIsLoadingSubtopics] = useState(false);
    const [selectedSubjectId, setSelectedSubjectId] = useState(null);
    const [selectedTopicId, setSelectedTopicId] = useState(null);
    const [selectedSubtopicId, setSelectedSubtopicId] = useState(null);
    const [isLoadingSubjects, setIsLoadingSubjects] = useState(false);
    const [topicdata, setTopicData] = useState(false);
    const [subjectdata, setSubjectdata] = useState(false);
    const [learn, setLearn] = useState("Learn");
    const [practice, setPractice] = useState("Practice");

    const [isListening, setIsListening] = useState(false);
    const recognitionRef = useRef(null);
    const [uploadLoader, setUploadLoader] = useState(false);

    const [files, setFiles] = useState([]);
    const [progress, setProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const formData = new FormData();

    // const handleUpload = async () => {
    //   setUploadLoader(true);
    //   if (!file) {
    //     alert("Please select a PDF file");
    //     return;
    //   }

    //   try {
    //     const res = await uploadPdfService(file);
    //     // setResponse(res.data);
    //      setSelectedPrompt({ text: "evaluate" });
    //     console.log("Response:", res.data);

    //     const usemessage = {
    //       sender: "user",
    //       message: "Please evaluate the uploaded document.",
    //       prompt: "evaluate",
    //       mcqData: null,
    //       topic: null,
    //       keywords: null,
    //       caseStudies: null,
    //       initiatives: null,
    //     };
    //     const botmesasage = {
    //       sender: "bot",
    //       message: res.data.evaluation,
    //       prompt: "evaluate",
    //       mcqData: null,
    //       topic: null,
    //       keywords: null,
    //       caseStudies: null,
    //       initiatives: null,
    //     };

    //     setMessages((prevMessages) => [
    //       ...prevMessages,
    //       usemessage,
    //       botmesasage,
    //     ]);
    //   } catch (error) {
    //     console.error("Upload error:", error);
    //   } finally {
    //     // setMessage("");
    //     setFile(null);
    //     setShowPromptType(true);
    //     setAttachFile(false);
    //     setUploadLoader(false);
    //   }
    // };

    const fileInputRef = useRef(null);

    const ALLOWED_TYPES = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    const MAX_SIZE = 10 * 1024 * 1024; // 10 MB

    // Raster image + document extensions (fallback when MIME type is missing)
    const ALLOWED_EXTENSIONS = [
      "pdf",
      "docx",
      "jpg",
      "jpeg",
      "png",
      "gif",
      "bmp",
      "tif",
      "tiff",
      "webp",
      "heic",
      "heif",
      "ico",
      "avif",
    ];

    // Validate File (type + size)
    const validateFile = (file) => {
      if (!file) return false;

      const ext = file.name.split(".").pop().toLowerCase();
      const isAllowedType =
        ALLOWED_TYPES.includes(file.type) ||
        file.type.startsWith("image/") ||
        ALLOWED_EXTENSIONS.includes(ext);

      if (!isAllowedType) {
        alert(
          "Invalid file type. Only PDF, DOCX and raster image files (JPEG, PNG, HEIC, WebP, BMP, TIFF, GIF, AVIF) are allowed."
        );
        return false;
      }

      if (file.size > MAX_SIZE) {
        alert("File exceeds maximum size of 10 MB.");
        return false;
      }

      return true;
    };

    // Click to upload
    const handleFileClick = () => {
      fileInputRef.current.click();
    };

    // Choose file input
    const handleFileChange = (e) => {
      addFiles(e.target.files);
      e.target.value = "";
    };

    // Drag enter
    const handleDragOver = (e) => {
      e.preventDefault();
    };

    // Drop files
    const handleDrop = (e) => {
      e.preventDefault();
      addFiles(e.dataTransfer.files);
    };

    // Add multiple files, sorted by creation time (serial)
    const addFiles = (fileList) => {
      const validFiles = [];
      for (const uploadedFile of fileList) {
        if (!validateFile(uploadedFile)) continue;
        validFiles.push(uploadedFile);
      }
      if (!validFiles.length) return;

      setFiles((prev) => {
        const existing = new Set(
          prev.map(({ file }) => `${file.name}-${file.size}-${file.lastModified}`)
        );
        const additions = validFiles
          .filter((f) => !existing.has(`${f.name}-${f.size}-${f.lastModified}`))
          .map((f) => ({
            id: Date.now() + Math.random(),
            file: f,
          }));

        return [...prev, ...additions]
          .sort((a, b) => a.file.lastModified - b.file.lastModified)
          .map((item, index) => ({ ...item, serial: index + 1 }));
      });
    };

    // Remove a file from the list
    const removeFile = (id) => {
      setFiles((prev) =>
        prev
          .filter((item) => item.id !== id)
          .map((item, index) => ({ ...item, serial: index + 1 }))
      );
    };

    // Drag to reorder the file list (updates serial)
    const dragIndexRef = useRef(null);
    const handleFileDragStart = (index) => {
      dragIndexRef.current = index;
    };
    const handleFileDragOver = (e) => {
      e.preventDefault();
    };
    const handleFileDrop = (targetIndex) => {
      const from = dragIndexRef.current;
      dragIndexRef.current = null;
      if (from === null || from === targetIndex) return;
      setFiles((prev) => {
        const next = [...prev];
        const [moved] = next.splice(from, 1);
        next.splice(targetIndex, 0, moved);
        return next.map((item, index) => ({ ...item, serial: index + 1 }));
      });
    };

    // Confirm the uploaded files
    const handleUpload = () => {
      if (files.length === 0) {
        alert("Please select at least one file.");
        return;
      }
      setFiledetail(files.map((item) => item.file));
      setEvaluateVisible(true);
      setAttachFile(false);
      setSelectedPrompt({ text: "evaluate" });
    };

    const [dropdownItems] = useState([
      {
        // Model Answer : See a Model Answer
        id: 1,
        label: "See a Model Answer",
        description: "To 'Why labor force...'",
        value: "See a Model Answer",
        image: "/assets/images/model-ans.svg",
      },
      // {
      //   label: "Practice MCQ",
      //   description: "To 'Why labor force...'",
      //   value: "Practice MCQ",
      //   image: "/assets/images/mcq-p.svg",
      // },

      {
        //  Essay Guidance : Frame Your Essay
        id: 2,
        label: "Frame Your Essay",
        description: "The ship in the harbor is safe, but...",
        value: "Frame Your Essay",
        image: "/assets/images/eassy-guidance-new.svg",
      },
      {
        //  Short Notes : Quick Topic Summary
        id: 3,
        label: "Quick Topic Summary",
        description: "Short Notes on 'plate tectonics'",
        value: "Quick Topic Summary",
        image: "/assets/images/short-notes.svg",
      },
      {
        //  Case Study : Explore a Case Study
        id: 4,
        label: "Explore a Case Study",
        description: "Case Study on 'Digital Divide'",
        value: "Explore a Case Study",
        image: "/assets/images/cas-study2.svg",
      },
      // {
      //   //  Approach : Plan Your Answer
      //   id: 5,
      //   label: "Plan Your Answer",
      //   description: "To 'Why labor force...'",
      //   value: "Plan Your Answer",
      //   image: "/assets/images/approach1.svg",
      // },
      // {
      //   id: 9,
      //   label: "Mains Practice",
      //   description: "On 'Why labor force...'",
      //   value: "Mains Practice",
      //   image: "/assets/images/write-pad.svg",
      // },
      // {
      //   id: 10,
      //   label: "Prelims Practice",
      //   description: "On 'Why labor force...'",
      //   value: "Prelims Practice",
      //   image: "/assets/images/write-pad.svg",
      // },
    ]);

    const [dropdownItemsPractiec] = useState([
      // {
      //   // Model Answer : See a Model Answer
      //   id: 1,
      //   label: "See a Model Answer",
      //   description: "To 'Why labor force...'",
      //   value: "See a Model Answer",
      //   image: "/assets/images/model-ans.svg",
      // },
      // {
      //   label: "Practice MCQ",
      //   description: "To 'Why labor force...'",
      //   value: "Practice MCQ",
      //   image: "/assets/images/mcq-p.svg",
      // },

      // {
      //   //  Essay Guidance : Frame Your Essay
      //   id: 2,
      //   label: "Frame Your Essay",
      //   description: "The ship in the harbor is safe, but...",
      //   value: "Frame Your Essay",
      //   image: "/assets/images/eassy-guidance-new.svg",
      // },
      // {
      //   //  Short Notes : Quick Topic Summary
      //   id: 3,
      //   label: "Quick Topic Summary",
      //   description: "Short Notes on 'plate tectonics'",
      //   value: "Quick Topic Summary",
      //   image: "/assets/images/short-notes.svg",
      // },
      // {
      //   //  Case Study : Explore a Case Study
      //   id: 4,
      //   label: "Explore a Case Study",
      //   description: "Case Study on 'Digital Divide'",
      //   value: "Explore a Case Study",
      //   image: "/assets/images/cas-study2.svg",
      // },
      // {
      //   //  Approach : Plan Your Answer
      //   id: 5,
      //   label: "Plan Your Answer",
      //   description: "To 'Why labor force...'",
      //   value: "Plan Your Answer",
      //   image: "/assets/images/approach1.svg",
      // },
      {
        id: 9,
        label: "Mains Practice",
        description: "On 'Why labor force...'",
        value: "Mains Practice",
        image: "/assets/images/write-pad.svg",
      },
      {
        id: 10,
        label: "Prelims Practice",
        description: "On 'Why labor force...'",
        value: "Prelims Practice",
        image: "/assets/images/write-pad.svg",
      },
    ]);

const closePopup = () => {
      setAttachFile(false);
    };

    const openAttachModal = () => {
      setFiles([]);
      setAttachFile(true);
    };

    // Fetch subjects when MCQ becomes visible
    useEffect(() => {
      const fetchSubjects = async () => {
        if (isMCQVisible) {
          try {
            const subjectsData = await getSubjects();
            const filteredSubjects = subjectsData.filter(
              (subject) => subject.disp_flag === 0
            );
            filteredSubjects.sort((a, b) => a.name.localeCompare(b.name));
            setSubjects(filteredSubjects);
          } catch (error) {
            console.error("Error fetching subjects:", error);
          }
        }
      };
      fetchSubjects();
    }, [isMCQVisible]);

    useEffect(() => {
      const fetchSubjects = async () => {
        if (!isMainsPracticeVisible) return;

        try {
          const response = await getSubjectsMains();

          // Access the subjects array from the response
          const subjects = response.subjects;

          setSubjectsMainPractice(subjects);
          // Sorting the plain array alphabetically
          // const sortedSubjects = [...subjects].sort((a, b) => a.localeCompare(b));
          // setSubjectsMainPractice(sortedSubjects);
          // console.log(subjectsmainpractice);
        } catch (error) {
          console.error("Error fetching subjects:", error);
        }
      };

      fetchSubjects();
    }, [isMainsPracticeVisible]);

    // Fetch topics and subtopics when subject is selected
    useEffect(() => {
      const fetchTopicsAndSubtopics = async () => {
        if (selectedSubject) {
          setIsLoadingSubtopics(true);
          try {
            const topicsData = await getTopicsAndSubtopics(selectedSubjectId);
            setTopicsAndSubtopics(topicsData);
          } catch (error) {
            console.error("Error fetching topics and subtopics:", error);
          } finally {
            setIsLoadingSubtopics(false);
          }
        }
      };
      fetchTopicsAndSubtopics();
    }, [selectedSubject]);


    useEffect(() => {
      const fetchTopicsAndSubtopics = async () => {
        if (selectedSubject) {
          setIsLoadingSubtopics(true);
          try {
            const topicsData = await getTopicsBySubject (selectedSubject);
            setMainstopic(topicsData);
          } catch (error) {
            console.error("Error fetching topics and subtopics:", error);
          } finally {
            setIsLoadingSubtopics(false);
          }
        }
      };
      fetchTopicsAndSubtopics();
    }, [selectedSubject]);

    useEffect(() => {
      if (message == "") {
        setButtonDisabled(true);
      } else {
        if (!isPrelims) setButtonDisabled(false);
      }
    }, [message]);

    useEffect(() => {
      // console.log(topicdata, "topicdata");
      // console.log(subjectdata, "subjectdata");
      if (topicdata && subjectdata) {
        setButtonDisabled(false);
      }
    });

    const messagesBlink = [
      "For creating mindmaps or charts, please choose the 'Short Note' template.",
      "Select a template to assist you better.",
    ];
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
      const interval = setInterval(() => {
        setIsVisible(false); // Start fade-out

        setTimeout(() => {
          setCurrentMessageIndex(
            (prevIndex) => (prevIndex + 1) % messagesBlink.length
          ); // Change message
          setIsVisible(true); // Start fade-in
        }, 500); // Wait 500ms for fade-out effect
      }, 3000); // Change message every 3 seconds

      return () => clearInterval(interval); // Cleanup on component unmount
    }, [messagesBlink.length]);

    useEffect(() => {
      if (selectedPrompt.text === "PYQ Mains") {
        fetchEssayTopics().then((data) => setEssayTopics(data));
      }
    }, [selectedPrompt.text]);

    useEffect(() => {
      setMessage(messageEdit);
    }, [messageEdit]);

    const editMessage = (message) => {
      setMessageEdit("");
      setMessage("");
      setMessageEdit(message);
      setMessage(messageEdit);
    };

    const handlePromptSelect = (prompt, imageName) => {
      setdropdownVisibl(false);
      if (isPrelims) {
        setMessage("");
        setIsPrelims(false);
      }

      setSelectedPrompt({ text: prompt, image: imageName });
      setDropdownVisible(false);

      if (prompt === "Prelims Practice") {
        setMCQVisible(true);
        setIsMainsPracticeVisible(false);
        setEvaluateVisible(false);
        setDefaultText("");
        setIsPrelims(true);
        setMessage(`Give me MCQ questions for ${selectedSubject} `);
      } else if (prompt === "Main Practice" || prompt === "Mains Practice") {
        setMCQVisible(false);
        setIsMainsPracticeVisible(true);
        setEvaluateVisible(false);
        setDefaultText("");
        setIsPrelims(true);
        setMessage(`Give me PYQs for  ${selectedSubject} `);
      } else if (prompt === "Case Study" || prompt === "Short Notes") {
        setDefaultText(``);
        if (isPrelims) {
          setMessage("");
          setIsPrelims(false);
        }
        setMCQVisible(false);
        setIsMainsPracticeVisible(false);
        setEvaluateVisible(false);
      } else if (prompt === "Evaluate") {
        setEvaluateVisible(true);
        setMCQVisible(false);
        setIsMainsPracticeVisible(false);
      } else {
        setDefaultText("");
        setEvaluateVisible(false);
        setMCQVisible(false);
        setIsMainsPracticeVisible(false);
      }
    };

    useImperativeHandle(ref, () => ({
      handleSelectPrompt: (promptType) => {
        if (promptType === "") {
          handlePromptSelect(selectedPrompt.text, "summarise.svg");
        } else {
          handlePromptSelect(promptType, "summarise.svg"); // Replace with the desired image name
        }
      },
      editMessage: (message) => {
        editMessage(message);
      },
      handlecutomSelect: () => {
        handlecutomSelect();
      },
    }));

    // Handle subject selection
    const handleSubjectSelect = (subject) => {
      setSubjectdata(true);
      setSelectedSubject(subject.name);
      setSelectedSubjectId(subject.id);
      setSelectedSubtopic(""); // Reset subtopic when subject changes
      setSelectedSubtopicId(null);
      setMessage(`Give me  MCQ questions for ${subject?.name}`);
    };

    // Handle number of questions selection
    const handleNumQuestionsSelect = (numQuestions) => {
      setSelectedNumQuestions(numQuestions);

      // Find the subject name
      const subjectObj = subjects.find((s) => s.id === selectedSubjectId);
      const subjectName = selectedSubject;

      // Find the subtopic name
      let subtopicName = "";
      topicsAndSubtopics.forEach((topic) => {
        const sub = topic.subtopics.find((st) => st.id === selectedSubtopicId);
        if (sub) subtopicName = sub.name;
      });

      setMessage(
        `Give me ${numQuestions} MCQ questions for ${subjectName} and the topic is ${subtopicName}`
      );
    };

    // Handle subtopic selection
    const handleSubtopicSelect = (topic) => {
      setTopicData(true);

      setSelectedTopicId(topic.id);

      // Find the subject name
      // const subjectObj = subjects.find((s) => s.id === selectedSubjectId);
      const subjectName = selectedSubject;

      // Find the topic name
      const topicName = topic.name;

      setMessage(
        `Give me MCQ questions for ${selectedSubject} and the topic is ${topicName}`
      );
    };

    // Add new state for input length
    const [inputLength, setInputLength] = useState(0);

    // Modify handleInputChange to track input length
    const handleInputChange = (e) => {
      let newMessage = e.target.value;

      // Remove emojis using regex
      // This regex covers most common emojis
      newMessage = newMessage.replace(
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]|\u24C2|\uD83D[\uDC00-\uDE4F])/g,
        ""
      );

      setInputLength(newMessage.length);

      if (selectedPrompt.text === "Evaluate") {
        setMessage(newMessage);
      } else {
        if (selectedPrompt.text === "MCQ") {
          setMessage(`Give me MCQ questions for ${selectedSubject}`);
        } else {
          if (
            selectedPrompt.text === "Case Study" ||
            selectedPrompt.text === "Short Notes"
          ) {
            setMessage(newMessage);
          } else {
            setMessage(newMessage);
          }
        }
      }

      // Enable button only if input length is at least 3
      // setButtonDisabled(newMessage.trim().split(/\s+/).length < 3);
    };

    // Handle sending the message
    const handleSend = () => {
      setMsgSend(false);

      if (selectedPrompt?.text) {
        if (
          selectedPrompt.text === "Prelims Practice" &&
          (!selectedSubject || !selectedNumQuestions)
        ) {
          alert("Please select a subject and the number of questions.");
          return;
        }

        if (selectedPrompt.text.trim() == "") {
          alert("Please select a subject and the number of questions.");
          return;
        }

        const payload = {
          message: message,
          prompt: selectedPrompt.text,
          mainsPractice:
            selectedPrompt.text === "Mains Practice" ||
            selectedPrompt.text === "Main Practice"
              ? {
                  subjects: demo,
                }
              : null,

          mcqData:
            selectedPrompt.text === "Prelims Practice"
              ? {
                  subjectId: selectedSubjectId,
                  topicId: selectedTopicId,
                  subtopicId: selectedSubtopicId,
                  numQuestions: selectedNumQuestions,
                }
              : null,
        };

        setShowPromptType(true);
        onSend(payload);
        setIsMainsPracticeVisible(false);
        setMessage("");
        setMCQVisible(false);
        setEvaluateVisible(false);
        setSelectedPrompt({ text: "Generic", image: "summarise.svg" });
        setSelectedSubject("");
        setSelectedSubjectId(null);
        setSelectedTopicId(null);
        setSelectedSubtopicId(null);
        // setSelectedNumQuestions("");
        // setButtonDisabled(true);
        setDefaultText("");
      } else {
        alert("Please enter a message or select a prompt.");
      }
    };

    useEffect(() => {
      if (selectedPrompt.text === "PYQ Mains") {
        setMessage(
          `Give me ${selectedTopic} PYQ questions for ${selectedSubjectPyq}`
        );
      }
    }, [selectedTopic, selectedSubjectPyq]);

    const handleTopicSelect = (topic, Subject) => {
      setSelectedTopic(topic);
      setselectedSubjectPyq(Subject);
      setMessage(
        `Give me ${selectedTopic} PYQ questions for ${selectedSubjectPyq}`
      );
    };

    // Remove selected prompt
    const removeSelectedPrompt = () => {
      setbuttonclicked("");
      setSelectedSubject("");
      setSelectedSubjectId(null);
      setIsMainsPracticeVisible(false);
      setDropdownVisible(false);
      setDropdownVisiblePractice(false);
      setPractice("Practice");
      setLearn("Learn");
      setTopicData(false);
      setSubjectdata(false);
      setMessage("");
      setSelectedPrompt({ text: "Generic", image: "summarise.svg" });
      setButtonDisabled(true);
      setMCQVisible(false);
      setEvaluateVisible(false);
      setDefaultText("");
      setIsPrelims(false);
    };

    const textareaRef = useRef(null);

    const handlecutomSelect = () => {
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
    };

    useEffect(() => {
      const handleKeyDown = (event) => {
        if (event.key === "Escape") {
          setDropdownVisible(false);
          setdropdownVisibl(false);
          setDropdownVisiblePractice(false);
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, []);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target) &&
          !event.target.closest(".selected-tag") &&
          !event.target.closest(".btn-question")
        ) {
          setDropdownVisible(false);
          setdropdownVisibl(false);
          setDropdownVisiblePractice(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    const showPromptList = () => {
      setDropdownVisible(!isDropdownVisible);
      setDropdownVisiblePractice(false);
    };
    const showPromptListPractice = () => {
      setDropdownVisiblePractice(!isDropdownVisiblePractice);
      setDropdownVisible(false);
    };

    const handleDropdownItemClick = (item) => {
      // Handle item click here
      setDropdownVisible(false);
      setDropdownVisiblePractice(false);
      setPromptType(item.value);
    };
    // console.log(selectedPrompt.text,"selectedPrompt.text")

    useEffect(() => {
      // Check if browser supports Speech Recognition
      if (
        !("webkitSpeechRecognition" in window || "SpeechRecognition" in window)
      ) {
        console.warn("Speech Recognition not supported in this browser.");
        return;
      }

      const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognition = new SpeechRecognition();

      recognition.lang = "en-IN";
      recognition.interimResults = true; // enable live partial results
      recognition.continuous = true; // keep listening until manually stopped

      recognition.onstart = () => {
        setIsListening(true);
      };

      recognition.onresult = (event) => {
        let fullTranscript = "";
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          fullTranscript += event.results[i][0].transcript + " ";
        }
        fullTranscript = fullTranscript.trim();

        // Append only finalized text
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          const result = event.results[i];
          if (result.isFinal) {
            const finalText = result[0].transcript.trim();
            if (finalText) {
              setMessage((prev) => `${prev} ${finalText}`.trim());
            }
          }
        }
      };

      recognition.onerror = (event) => {
        console.error("❌ Speech recognition error:", event.error);
      };

      recognition.onend = () => {
        // Only restart if user did NOT manually stop
        if (!recognition._manualStop) {
          recognition.start();
        } else {
          setIsListening(false);
        }
      };

      // Save recognition instance
      recognitionRef.current = recognition;

      // Cleanup on unmount
      return () => {
        recognition._manualStop = true;
        recognition.stop();
      };
    }, [setMessage]);

    const handleMicClick = () => {
      if (!recognitionRef.current) return;

      const recognition = recognitionRef.current;

      if (isListening) {
        // Pause
        recognition._manualStop = true;
        recognition.stop(); // stops the recognition
        setIsListening(false);
      } else {
        // Start listening
        recognition._manualStop = false;
        recognition.start(); // starts recognition
        setIsListening(true);
      }
    };

    return (
      <div
        className={
          isMCQVisible ||
          isEvaluateVisible ||
          isMainsPracticeVisible ||
          selectedPrompt.text === "PYQ Mains" ||
          selectedPrompt.text != "Generic"
            ? "input-container input-box mb-0"
            : "input-box mb-0"
        }
        id="textInputBox"
      >
        <div className="row">
          <div className="col-12" id="prompt-input-screen">
            {isMCQVisible && (
              <div className="">
                <div id="mcq_buttons" className="mcq_buttons_class">
                  {/* Select Subject Section */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <img
                        src="/assets/images/new-arrow.svg"
                        alt="Logo"
                        style={{ marginLeft: "10px" }}
                      />
                      <span
                        style={{
                          marginLeft: "8px",
                          fontFamily: '"Source Sans 3", sans-serif',
                          fontWeight: 500,
                          fontSize: "13px",
                          lineHeight: 1,
                          letterSpacing: 0,
                          color: "#49546C",
                        }}
                      >
                        Prelims Practice
                      </span>
                    </div>
                    <div>
                      <img
                        src="/assets/images/new-close.svg"
                        alt="Logo"
                        style={{ marginRight: "6px" }}
                        onClick={removeSelectedPrompt}
                      />
                    </div>
                  </div>
                  <p className="select-text">Select Subject</p>
                  <div className="oval-container" id="subjectContainer">
                    {isLoadingSubjects ? (
                      <div className="loader">
                        <div id="loadingSpinner">
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div className="d-flex dots">
                              <div className="dot"></div>
                              <div className="dot"></div>
                              <div className="dot"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      subjects.map((subject) => (
                        <div
                          key={subject.id}
                          className="oval selectable"
                          role="button"
                          tabIndex="0"
                          data-selected={selectedSubjectId === subject.id}
                          onClick={() => handleSubjectSelect(subject)}
                        >
                          {subject.name}
                        </div>
                      ))
                    )}
                  </div>
                  {selectedSubject && (
                    <>
                      <p className="select-text">Select Topic</p>
                      <div className="oval-container" id="subtopicContainer">
                        {isLoadingSubtopics ? (
                          <div className="loader">
                            <div id="loadingSpinner">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div className="d-flex dots">
                                  <div className="dot"></div>
                                  <div className="dot"></div>
                                  <div className="dot"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          topicsAndSubtopics.map((topic) => (
                            <div
                              key={topic.id}
                              className="oval selectable"
                              role="button"
                              tabIndex="0"
                              data-selected={selectedTopicId === topic.id}
                              onClick={() =>
                                 handleSubtopicSelect(topic)}
                            >
                              {topic.name}
                            </div>
                          ))
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}

      {isMainsPracticeVisible && (
  <div>
    <div id="mcq_buttons" className="mcq_buttons_class">
      {/* Header */}
      <div
        style={{
          padding:"6px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <img
            src="/assets/images/new-arrow.svg"
            alt="Logo"
            style={{ marginLeft: "10px" }}
          />
          <span
            style={{
              marginLeft: "8px",
              fontFamily: '"Source Sans 3", sans-serif',
              fontWeight: 500,
              fontSize: "13px",
              lineHeight: 1,
              color: "#49546C",
            }}
          >
            Mains Practice
          </span>
        </div>
        <img
          src="/assets/images/new-close.svg"
          alt="Close"
          style={{ marginRight: "6px", cursor: "pointer" }}
          onClick={removeSelectedPrompt}
        />
      </div>

      {/* Select Subject */}
      <p className="select-text">Select Subject</p>
      <div className="oval-container" id="subjectContainer">
        {isLoadingSubjects ? (
          <div className="loader">
            <div id="loadingSpinner">
              <div className="d-flex dots">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            </div>
          </div>
        ) : (
          subjectsmainpractice.map((sub, index) => (
            <div
              key={sub}
              className="oval selectable"
              role="button"
              tabIndex="0"
              data-selected={selectedSubject === sub}
              onClick={() => {
                setSelectedSubject(sub);
                setDemo(sub);
                setMessage(`Give me PYQs for ${sub}`);
                setButtonDisabled(false);
              }}
            >
              {sub}
            </div>
          ))
        )}
      </div>

      {/* Select Topic (only after subject selection) */}
      {selectedSubject && (
        <>
          <p className="select-text">Select Topic</p>
          <div className="oval-container" id="subtopicContainer">
            {isLoadingSubtopics ? (
              <div className="loader">
                <div id="loadingSpinner">
                  <div className="d-flex dots">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                </div>
              </div>
            ) : (
              mainstopics?.[selectedSubject]?.map((topic, index) => (
                <div
                  key={topic}
                  className="oval selectable"
                  role="button"
                  tabIndex="0"
                  data-selected={selectedTopic === topic}
                  onClick={() =>{
                    setSelectedTopic(topic)

                     setMessage(
        `Give me PYQs for ${selectedSubject} and the topic ${topic}`
      );
                    }}
                >
                  {topic}
                </div>
              ))
            )}
          </div>
        </>
      )}
    </div>
  </div>
)}


            {selectedPrompt.text === "PYQ Mains" && essayTopics.topics && (
              <PyqSubjects
                removeSelectedPrompt={removeSelectedPrompt}
                data={essayTopics}
                handleTopicSelectPyq={handleTopicSelect}
                handlecutomSelect={handlecutomSelect}
              />
            )}

            {![
              "PYQ Mains",
              "Evaluate",
              "Generic",
              "Prelims Practice",
              "Main Practice",
              "Mains Practice",
            ].includes(selectedPrompt.text) && (
              <div className="">
                <div id="mcq_buttons" className="mcq_buttons_class">
                  {/* Select Subject Section */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      // backgroundColor: "#F5F8F9",
                      borderRadius: "10px",
                      margin: "1px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <img
                        src="/assets/images/new-arrow.svg"
                        alt="Logo"
                        style={{ marginLeft: "10px" }}
                      />
                      <span
                        style={{
                          marginLeft: "10px",
                          fontFamily: '"Source Sans 3", sans-serif',
                          fontWeight: 500,
                          fontSize: "13px",
                          lineHeight: 1,
                          letterSpacing: 0,
                          color: "#49546C",
                        }}
                      >
                        {selectedPrompt.text == "evaluate"
                          ? "Answer Evaluation"
                          : selectedPrompt.text}
                      </span>
                    </div>
                    <div>
                      <img
                        src="/assets/images/new-close.svg"
                        alt="Logo"
                        style={{ marginRight: "6px" }}
                        onClick={removeSelectedPrompt}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isEvaluateVisible && (
              <FileUpload
                filedata={files}
                setAttachmark={setAttachmark}
                setAttchsubject={setAttchsubject}
                onRemoveFile={removeFile}
                onAddFiles={addFiles}
              />
            )}
          </div>
        </div>
        {showPremiumButton && (
          <div
           className="show-premium-line"     
          >
            <span className="show-premium-line-text">Loving Yooki? Pro is where it gets powerfull</span>
            <div className="unlock-pro-gradient"  onClick={() => { navigate("/Price");}}>
              <div className="unlock-pro">
                <span>
                  <img src="/assets/images/lock-closed-icon-mcq.svg" alt="" />
                </span>
                Unlock with PRO
              </div>
            </div>{" "}
          </div>
        )}
        <div className="row chatInput-Container m-auto">
          <div className="col-12 pl-0 pr-0 pb-0 text-area-container">
            <textarea
              ref={textareaRef}
              className="form-control input-box-def input-box-def-select p-0"
              id="userInput"
              disabled={!isStreamingDone}
              rows="2"
              placeholder={
                selectedPrompt.text === "evaluate"
                  ? `Type your question here`
                  : defaultText
                  ? `${defaultText}`
                  : "Ask me anything..."
              }
              value={message}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  handleSend();
                  // const wordCount = message
                  //   .trim()
                  //   .split(/\s+/)
                  //   .filter((word) => word !== "").length;
                  // if (wordCount >= 3) {
                  //   handleSend();
                  // }
                }
              }}
              onChange={(e) => {
                const words = e.target.value.trim().split(/\s+/);
                if (
                  words.length <= 1000 ||
                  e.target.value.length < message.length
                ) {
                  handleInputChange(e);
                }
              }}
            />
            {/* <div className="text-muted small text-end text-count">
              {message.trim() ? message.trim().split(/\s+/).length : 0}/100 words
            </div> */}
          </div>

          <div className="promptandIcon-container p-0 ">
            <div className="prompt-icon-container-test">
              {showPromptType && (
                <div
                  className={`prompt-text-container w-100 ${
                    isDropdownVisible || learn !== "Learn" ? "active" : ""
                  }`}
                >
                  <label
                    className="selected-type d-flex"
                    style={{
                      alignItems: "center",
                    }}
                  >
                    {/* <span
                      id="prompt-dropdown"
                      className="prompt-toggle"
                      onClick={() => setDropdownVisible((prev) => !prev)}
                      style={{ display: "flex" }}
                    >
                      <img
                        src="/assets/images/add-icon.svg"
                        alt="Open prompt"
                        id="prompt-select-icon"
                        className="prompt-select-icon"
                      />
                      <span
                        style={{
                          fontFamily: "Source Sans 3, sans-serif",
                          fontWeight: 400,
                          fontSize: "13px",
                          lineHeight: "100%",
                          letterSpacing: "0.5px",
                          color: "#7B869B",
                          marginTop:"3px",
                          marginLeft:"5px"
                        }}
                      >
                        Attach for evaluation
                      </span>
                    </span> */}
                    <span id="selected-content-chatinput">
                      <span
                        className="selected-tag d-flex align-items-center"
                        onClick={showPromptList}
                      >
                        <img
                          src={`/assets/images/book-open.svg`}
                          className="icon-prompt icon-prompt-img me-2"
                          alt={selectedPrompt.text}
                        />
                        {selectedPrompt.text === "Generic" ? "Learn" : learn}
                        {/* <img
                          src="//assets/images/down-arrow.svg"
                          id="remove-prompt"
                          className="ms-2"
                          alt="Close"
                          style={{ cursor: "pointer", verticalAlign: "initial" }}
              
                        /> */}
                      </span>
                    </span>
                  </label>
                </div>
              )}
              {showPromptType && (
                <div
                  className={`prompt-text-container w-100 ${
                    isDropdownVisiblePractice || practice !== "Practice"
                      ? "active"
                      : ""
                  }`}
                >
                  <label
                    className="selected-type d-flex"
                    style={{
                      alignItems: "center",
                    }}
                  >
                    {/* <span
                      id="prompt-dropdown"
                      className="prompt-toggle"
                      onClick={() => setDropdownVisible((prev) => !prev)}
                      style={{ display: "flex" }}
                    >
                      <img
                        src="/assets/images/add-icon.svg"
                        alt="Open prompt"
                        id="prompt-select-icon"
                        className="prompt-select-icon"
                      />
                      <span
                        style={{
                          fontFamily: "Source Sans 3, sans-serif",
                          fontWeight: 400,
                          fontSize: "13px",
                          lineHeight: "100%",
                          letterSpacing: "0.5px",
                          color: "#7B869B",
                          marginTop:"3px",
                          marginLeft:"5px"
                        }}
                      >
                        Attach for evaluation
                      </span>
                    </span> */}
                    <span id="selected-content-chatinput">
                      <span
                        className="selected-tag d-flex align-items-center"
                        onClick={showPromptListPractice}
                      >
                        <img
                          src={`/assets/images/practice-chatinput.svg`}
                          className="icon-prompt icon-prompt-img me-2"
                          alt={selectedPrompt.text}
                        />
                        {selectedPrompt.text === "Generic"
                          ? "Practice"
                          : practice}
                        {/* <img
                          src="//assets/images/down-arrow.svg"
                          id="remove-prompt"
                          className="ms-2"
                          alt="Close"
                          style={{ cursor: "pointer", verticalAlign: "initial" }}
              
                        /> */}
                      </span>
                    </span>
                  </label>
                </div>
              )}
              {showattachment && (
                <div
                  className={`attch-box ${
                    showPromptType ? "" : ""
                  }`}
                  onClick={openAttachModal}
                >
                  <img
                    src="/assets/images/attach.svg"
                    alt=""
                    height={16}
                    width={16}
                  />
                 Evaluate
                </div>
              )}
            </div>

            {!selectedPrompt || selectedPrompt.text === "Generic" ? (
              <div className="prompt-icon-container">
                <label className="content-type">
                  {/* <span
                    id="prompt-dropdown"
                    className="prompt-toggle"
                    onClick={() => setDropdownVisible((prev) => !prev)}
                    style={{ display: "flex" }}
                  >
                    <img
                      src="/assets/images/add-icon.svg"
                      alt="Open prompt"
                      id="prompt-select-icon"
                      className="prompt-select-icon"
                    />
                    <span
                      style={{
                        fontFamily: "Source Sans 3, sans-serif",
                        fontWeight: 400,
                        fontSize: "13px",
                        lineHeight: "100%",
                        letterSpacing: "0.5px",
                        color: "#7B869B",
                        marginTop:"3px",
                        marginLeft:"5px"
                      }}
                    >
                      Attach for evaluation
                    </span>
                  </span> */}
                </label>
                <div className="p-0"></div>
              </div>
            ) : (
              ""
            )}
            {/* dropdown-menu i delete this name form dropdown bcs of width issue */}
            {/* {isdropdownVisibl && (
              <ul
                ref={dropdownRef}
                className="dropdown-menu-end show model-prompt"
                style={{
                  position: "fixed",
                  left: dropdownPosition.left,
                  top: dropdownPosition.top - 80, // Adjust 100 to the height of your dropdown
                  borderRadius: "11px",
                  border: "1px solid #E1E7EA",
                  padding: "4px 8px",
                  cursor: "pointer",
                  zIndex: 9999,
                }}
              >
                <li
                  className="m-0"
                  onClick={() =>
                    handlePromptSelect("Prelims Practice", "practice.svg")
                    
                  }
                >
                  <img
                    src="/assets/images/practice.svg"
                    className="icon-prompt"
                    alt="Practice PYQs"
                  />
                  <span className="dropdown-item1 btn-prompt">
                    Prelims Practice
                  </span>
                </li>
                <li
                  className="m-0"
                  onClick={() =>
                    handlePromptSelect("Main Practice", "main-practice.svg")
                  }
                >
                  <img
                    src="/assets/images/main-practice.svg"
                    className="icon-prompt"
                    alt="Main Practice"
                  />
                  <span className="dropdown-item1 btn-prompt">
                    Mains Practice
                  </span>
                </li>
              </ul>
            )} */}
            {isDropdownVisible && (
              <div
                ref={dropdownRef}
                className="custom-dropdown-menu"
                style={{
                  position: "fixed",
                  bottom: "70px",
                  left: "13%",
                  backgroundColor: "white",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  borderRadius: "8px",
                  padding: "4px 8px",
                  zIndex: 1000,
                  // minWidth: "200px",
                  marginBottom: "4px",
                  border: "0.5px solid #e1e7ea",
                }}
              >
                {dropdownItems.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => {
                      if (
                        prompt === "Mains Practice" ||
                        prompt === "Main Practice"
                      ) {
                        handlePromptSelect(
                          "Main Practice",
                          "main-practice.svg"
                        );
                      } else {
                        setLearn(item.label);
                        setPractice("Practice");
                        handleDropdownItemClick(item);
                      }
                    }}
                    style={{
                      padding: "2px 8px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f5f5f5")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <img
                      src={item.image}
                      alt={item.label}
                      style={{ width: "14px", height: "14px" }}
                    />
                    <span style={{ fontSize: "14px" }}>{item.label}</span>
                  </div>
                ))}
              </div>
            )}
            {isDropdownVisiblePractice && (
              <div
                onClick={() => {
                  setbuttonclicked("clicked-item");
                }}
                ref={dropdownRef}
                className="custom-dropdown-menu-practice"
                style={{
                  position: "fixed",
                  bottom: "70px",
                  left: "17%",
                  backgroundColor: "white",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  borderRadius: "8px",
                  padding: "4px 8px",
                  zIndex: 1000,
                  // minWidth: "200px",
                  marginBottom: "4px",
                  border: "0.5px solid #e1e7ea",
                }}
              >
                {dropdownItemsPractiec.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => {
                      if (
                        prompt === "Mains Practice" ||
                        prompt === "Main Practice"
                      ) {
                        setPractice(item.label);
                        setLearn("Learn");
                        handlePromptSelect(
                          "Main Practice",
                          "main-practice.svg"
                        );
                      } else {
                        setPractice(item.label);
                        setLearn("Learn");
                        handleDropdownItemClick(item);
                      }
                    }}
                    style={{
                      padding: "2px 8px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f5f5f5")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <img
                      src={item.image}
                      alt={item.label}
                      style={{ width: "14px", height: "14px" }}
                    />
                    <span style={{ fontSize: "14px" }}>{item.label}</span>
                  </div>
                ))}
              </div>
            )}
            <div className="mic-send">
              {/* {  showattachment && <div
                className="attch-box"
                onClick={() => { 
                  setAttachFile(true);
                }}
              >
                <img src="/assets/images/attach.svg" alt="" />
                Attach
              </div>} */}

              <div className="mic-wrapper">
                <div className="mic-container">
                  {isListening && <div className="mic-pulse"></div>}
                  <button
                    onClick={handleMicClick}
                    className={`mic-btn ${
                      isListening ? "btn-pause" : "btn-record"
                    }`}
                  >
                    {isListening ? (
                      <Pause size={22} color="#FF3B30" strokeWidth={2.2} />
                    ) : (
                      <Mic size={22} color="#7B869B" strokeWidth={2.2} />
                    )}
                  </button>
                </div>
              </div>
              {/* 🚀 Send Button */}
              <button
                id="send_default"
                className={
                  isButtonDisabled
                    ? "send-icon p-0"
                    : "send-icon p-0 sendicon-active"
                }
                disabled={isButtonDisabled}
                onClick={() => {
                  if (isListening && recognitionRef.current) {
                    recognitionRef.current._manualStop = true;
                    recognitionRef.current.stop();
                    setIsListening(false);
                  }
                  handleSend(); // ✉️ trigger send after stopping mic
                }}
              >
                {isButtonDisabled ? (
                  <img
                    src="/assets/images/demo.svg"
                    className="send-icon"
                    alt="send"
                  />
                ) : (
                  <img
                    src="/assets/images/newsend-button.svg"
                    className="send-icon"
                    alt="send"
                  />
                )}
              </button>
            </div>
          </div>
        </div>

        <div
          className={`payment-success-overlay ${attachFile ? "p-active" : ""}`}
          aria-hidden={!attachFile}
        >
          <div
            className="payment-success-popup"
            role="dialog"
            aria-modal="true"
          >
            <div className="payment-success-wrapper">
              <div className="attach-file-model">
                {/* HEADER */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <span className="answer-ev">
                      Submit Your Answer for Evaluation
                    </span>
                    <span className="answer-ev-para">
                      Upload answer files to get your answer evaluated
                    </span>
                  </div>
                  <div style={{ cursor: "pointer" }} onClick={closePopup}>
                    <img
                      src="/assets/images/close-button.svg"
                      alt=""
                      width={29}
                      height={29}
                    />
                  </div>
                </div>

                {/* UPLOAD BOX */}
                <div className="upload-div-file-card">
                  <div
                    className="upload-div-file"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  >
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      multiple
                      accept=".pdf,.docx,.jpg,.jpeg,.png,.gif,.bmp,.tiff,.webp,.heic,.heif,.ico,.avif"
                      onChange={handleFileChange}
                    />

                    {files.length > 0 ? (
                      <div className="upload-file-list">
                        {files.map((item, index) => (
                          <div
                            key={item.id}
                            className="upload-file-item"
                            draggable
                            onDragStart={() => handleFileDragStart(index)}
                            onDragOver={handleFileDragOver}
                            onDrop={() => handleFileDrop(index)}
                          >
                            <span className="upload-file-serial">
                              {item.serial}
                            </span>
                            <img
                              src="/assets/images/mingcute_pdf-fill.svg"
                              alt=""
                              width={20}
                              height={20}
                            />
                            <span
                              className="upload-file-name"
                              title={item.file.name}
                            >
                              {item.file.name}
                            </span>
                            <span
                              className="upload-file-remove"
                              onClick={(e) => {
                                e.stopPropagation();
                                removeFile(item.id);
                              }}
                            >
                              <img
                                src="/assets/images/close-icon-file-box.svg"
                                alt="remove"
                                width={16}
                                height={16}
                              />
                            </span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <>
                        <img
                          src="/assets/images/file-upload-chatwindow.svg"
                          width={59}
                          height={59}
                          alt=""
                        />

                        <span>
                          <span
                            className="click-to-upload"
                            onClick={handleFileClick}
                          >
                            Click to upload
                          </span>
                          <span className="or-drag">
                            {" "}
                            or drag and drop files here.
                          </span>
                        </span>

                        <span
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <span className="support-format-text">
                        Supports PDF, Documents and Images
                          </span>
                          <span className="support-format-text">
                            Maximum size : 10 MB
                          </span>
                        </span>
                      </>
                    )}

                    {files.length > 0 && (
                      <span
                        className="click-to-upload add-more-files"
                        onClick={handleFileClick}
                      >
                        + Add more files
                      </span>
                    )}
                  </div>
                </div>

                {/* BUTTONS */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "12px",
                  }}
                >
                  <div className="cancel-button" onClick={closePopup}>
                    Cancel
                  </div>
                  <div className="eval-button" onClick={handleUpload}>
                    Evaluate
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default ChatInput;
